module.exports = __webpack_public_path__ + "static/media/pauze.25f829c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/pauze.svg
// module id = 625
// module chunks = 0